export class AviationEventInteractions {
  /**
   * If this review has been reported offensive
   */
  reportedOffensive: boolean;
  /**
   * If this user has reported this review offensive
   */
  myReportedOffensive: boolean;

  /**
   * Parses reviewSubrating
   * @param data {any} ReviewSubrating data as returned by API
   * @return {ReviewSubrating} Parsed ReviewSubrating
   */
  static parse(data: any): AviationEventInteractions {
    return {
      reportedOffensive: data.reportedOffensive,
      myReportedOffensive: data.myReportedOffensive
    };
  }
}
